import * as React from "react";
import { Button, Progress, notification, message } from "antd";
// import { dispatch, getState } from "@rematch/core";
import { connect } from "react-redux";
import _ from "lodash";

interface IExportExcelProcessProcess {
  // 导出进度
  num: any;
  // 导出进程状态
  status: any;
  updateExportProcess: any;
  // 导出方法
  exportContent?: React.ReactNode;
  params: any;
  queryAndExport: any;
  requestUrl: any;
}

class CommonExcelExportBtn extends React.Component<
  IExportExcelProcessProcess,
  any
> {
  state = {
    isExport: false,
    msg: "正在导出,完成后将自动下载文件"
  };

  constructor(props: IExportExcelProcessProcess) {
    super(props);
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    // updateDownloadProcess(nextProps, prevState);

    if (nextProps.status === "complete") {
      // 显示进度提醒的判断
      notification.open({
        message: prevState.msg,
        key: "ExportProcess",
        duration: null,
        description: (
          <div>
              <Progress percent={nextProps.num} size="default" status="active" />
              点击下载==>> <a href={"https://erpapi.cattrip.net/erp/custom/download?file=" + nextProps.file } >{nextProps.file}</a>
          </div>
        ),
        onClose:()=>{
          nextProps.cleanExportState();
        }
      });
    } else if (nextProps.status === "active") {
      // 显示进度提醒的判断
      notification.open({
        message: prevState.msg,
        key: "ExportProcess",
        duration: null,
        description: (
          <Progress percent={nextProps.num} size="default" status="active" />
        ),
        onClose:()=>{
          nextProps.cleanExportState();
        }
      });
    }
    return null;
  }

  // 事件处理回调
  handleCB = () => {
    if (
      this.props.status === "active"
    ) {
      message.warning("有其它导出任务，请等待");
      return;
    } else {
      let queryParams = this.props.params();
      //判断属性的个数
      if(_.keys(queryParams) && _.keys(queryParams).length >= 3){
        this.setState({
          isExport: true
        });
        this.props.updateExportProcess({
          num: 0,
          status: "active"
        });
        this.props.queryAndExport({params: queryParams, requestUrl: this.props.requestUrl});
      }else{
        message.warning("无筛选条件，不允许导出表格！");
      }
    }
  };

  render() {
    const buttonStyle = {
      backgroundColor: "#2b9fbd",
      borderColor: "#2b9fbd"
    };
    return (
      <Button type="primary" style={buttonStyle} onClick={this.handleCB}>
        导出Excel
      </Button>
    );
  }
}

const mapState = state => ({
  num: state.fileExport.exportProcess.num,
  status: state.fileExport.exportProcess.status,
  file: state.fileExport.exportProcess.file,
});

const mapDispatch = dispatch => {
  return {
    updateExportProcess: dispatch.fileExport.updateExportProcess,
    queryAndExport: dispatch.fileExport.queryAndExport,
    cleanExportState: dispatch.fileExport.cleanExportState,
  };
};

export default connect(
  mapState,
  mapDispatch
)(CommonExcelExportBtn);
